import { CallEffect, put } from 'redux-saga/effects'

/**
 * A helper that creates sagas for calling APIs. It calls the call
 * effects, then it generates a put effect of name + Success or
 * name + Failure.
 *
 * @returns {Generator} a combination of call and put effects
 *
 * @example
 *
 * import createSaga from '...'
 *
 * const fetchDataSaga = createSaga('fetchData', call(fetch, '/data'))
 *
 * function reducer(state, action) {
 *   switch (action.type) {
 *     case 'fetchDataSuccess':
 *       return {
 *         ...state,
 *         data: action.payload
 *       }
 *     case 'fetchDataFailure':
 *       return {
 *         ...state,
 *         isError: true,
 *         error: action.payload
 *       }
 *   }
 * }
 */
export function createFetchSaga(name: string, apiCall: CallEffect<any>) {
  return function* callApiSaga() {
    try {
      const response = yield apiCall
      yield put({ type: `${name}Success`, payload: response.data })
    } catch (error) {
      yield put({ type: `${name}Failure`, payload: error })
    }
  }
}
